module.exports = __webpack_public_path__ + "img/model2.55621831.jpg";